import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class SignTimeSheet extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {}
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        await this.props.dispatch(this.props.dataItem.reset());
        await this.props.dispatch(this.props.dataItem.initialize({}, {withParams: true}));
        await this.props.dispatch(this.props.dataItem.treeOperation(0, true));
        const params = this.props.dataItem_Params.getRow(0);
        await this.props.dispatch(this.props.dataItem_Options.execute(params));
        await this.props.dispatch(this.props.dataItem_History.execute(params));
    }

    sign = async () => {
        if (!this.props.dataItem_Options.isInitialized || this.props.dataItem_Options.rowsCount() === 0) {
            return null;
        }
        const options = this.props.dataItem_Options.getRow(0);
        try {
            options['SignDialogText'] && await confirm(options['SignDialogText']);
            await this.props.dispatch(this.props.dataItem_Sign.applyParams(this.props.dataItem_Params));
            await this.refresh();
        } catch (e) {
        }
    }

    refresh = async () => {
        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params));
        await this.props.dispatch(this.props.dataItem_Options.applyParams(this.props.dataItem_Params));
        await this.props.dispatch(this.props.dataItem_History.applyParams(this.props.dataItem_Params));
    }

    afterApplyParams = async () =>  {
        await this.props.dispatch(this.props.dataItem_Options.applyParams(this.props.dataItem_Params));
        await this.props.dispatch(this.props.dataItem_History.applyParams(this.props.dataItem_Params));
    }

    getDocument = async (event) => {
        event.preventDefault();
        const row_Params = this.props.dataItem_Params.getRow(0);
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "SignTimeSheet", "DownloadDocument") + "?" + $.param({
            b_token: token,
            filtTabelGroupId: row_Params['FiltTabelGroupId'],
            filtRCurMonth: row_Params['FiltRCurMonth'],
            selfTabNum: row_Params['SelfTabNum']
        });
        window.open(downloadPath, '_blank');
    }

    render() {
        const renderButtons = () => {
            if (!this.props.dataItem_Options.isInitialized || this.props.dataItem_Options.rowsCount() === 0) {
                return null;
            }
            const options = this.props.dataItem_Options.getRow(0);
            const toAllowVisualize = options['ToAllowVisualize'] === 1;
            const toAllowSign = options['ToAllowSign'] === 1;
            return (<div className="modal-footer text-left">
                {toAllowSign &&
                    <button type="button"
                            className="btn btn-regular -goahead  ml1ex"
                            onClick={this.sign}>{i18next.t("Sign")}</button>
                }
                {toAllowVisualize &&
                    <button type="button" className="btn btn-regular -goahead ml1ex"
                            onClick={this.getDocument}>{i18next.t("View_Download_EDoc")}
                    </button>
                }
            </div>)
        }

        if (!this.props.dataItem.isInitialized)
            return null;
        let gridTitleText = i18next.t("Daily_Timesheet");
        return (
            <>
                <PlaceholderWrapper placeholderId="filters"
                                    title={<><i className='fa fa-filter'/> {i18next.t("Filters")}</>}
                                    showSplitterLine={false}
                                    canCollapse={true}
                                    collapsed={true}
                >
                    <ComplexParam dataItem={this.props.dataItem_Params}
                                  readOnly={false}
                                  showSearchBar={true}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  afterApplyParams={this.afterApplyParams}
                                  rootPath="/"
                                  parentDataItem={this.props.dataItem}
                                  renderParams={paramRender}
                    />
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="tabels"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={gridTitleText}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    {renderButtons()}
                    <GridView dataItem={this.props.dataItem} fixHeader={true} readOnly={true}
                              contentContainerStyleProvider={this.gridContentContainerStyleProvider}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="history"
                                    title={<><i className='fa fa-history'/> {i18next.t("History")}</>}
                                    showSplitterLine={true}
                                    collapsed={true}
                                    canCollapse={true}
                >
                    <GridView dataItem={this.props.dataItem_History} readOnly={true} />
                </PlaceholderWrapper>
            </>
        );
    }

    gridContentContainerStyleProvider = ({mobileMode}) => {
        if (!mobileMode) {
            let height = 700;
            return {
                minHeight: "200px", height: "60vh"
            };
        }
    }
}

SignTimeSheet.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object,
    dataItem_Sign: PropTypes.object,
    dataItem_Options: PropTypes.object,
    dataItem_History: PropTypes.object
}

SignTimeSheet.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.signTimeSheetState.TabelDetail_TabelChiefPO_View,
        dataItem_Params: state.signTimeSheetState.TabelDetail_TabelChiefPO_ViewParams,
        dataItem_Sign: state.signTimeSheetState.TabelDetail_TabelChiefPO_Do_SetMySign,
        dataItem_Options: state.signTimeSheetState.TabelDetail_TabelChiefPO_CtrlParams,
        dataItem_History: state.signTimeSheetState.TabelDetail_TabelHistPO_View
    }
}

export default connect(mapStateToProps)(SignTimeSheet);